export default "__VITE_ASSET__BFVH0AXb__"